import dayjs from 'dayjs';

const utc = require('dayjs/plugin/utc');
dayjs.extend(utc);

const getCalendarDescription = (type, { heading, serviceName, phoneNumber }) => {
  let description =
    type === 'google'
      ? `<p><b>${serviceName}</b></p><p>${heading}</p><p>tel: ${phoneNumber}</p>`
      : `${serviceName}, ${heading}, tel: ${phoneNumber}`;

  return description;
};

export default getCalendarDescription;
